export interface DocumentAccess {
  id: string;
  userInfo: {
    id: string;
    fullName: string;
    status: string;
  };
  type: DocumentAccessTypes;
  grantedBy: string;
  createdAt: string;
  updatedAt: string;
}

export enum DocumentAccessTypes {
  "CREATOR" = "CREATOR",
  "VIEW" = "VIEW",
  "CO_EDITOR" = "CO_EDITOR",
}
